export const tourInfoData = [
  {
    iconClass: "envelope",
    text: "   Email",
    spanText: "William@jourrapide.com",
  },
  {
    iconClass: "calendar",
    text: "   BOD",
    className: "ttl-sm-mb-0",
    spanText: "02 January 1988",
  },
];

export const tourAddressData = [
  {
    colClass: "mt-0 mt-sm-3",
    iconClass: "phone",
    text: "   Contact Us",
    className: "ttl-xs-mt",

    spanText: "US 310-273-0666",
  },
  {
    iconClass: "location-arrow",
    text: "   Location",
    className: "ttl-sm-mb-0",
    spanText: "4377 Libby Street Beverly Hills",
  },
];

export const socialData = [
  {
    href: "https://www.facebook.com/",
    icon: "facebook",
  },
  {
    href: "https://accounts.google.com/",
    icon: "google-plus",
  },
  {
    href: "https://twitter.com/",
    icon: "twitter",
  },
  {
    href: "https://www.instagram.com/",
    icon: "instagram",
  },
  {
    href: "https://rss.app/",
    icon: "rss",
  },
];

export const commonFooterData = [
  {
    className: "b-r-gray pe-3",
    icon: "heart",
    text: " Like",
  },
  {
    className: "b-r-gray pe-3",
    icon: "comment",
    text: " Comment",
  },
  {
    icon: "paper-plane",
    text: " Share",
  },
];

//Tour
export const tourSteps = [
  {
    target: ".step1",
    content: "This is Wool profile",
  },
  {
    target: ".step2",
    content: "Change Wool profile image here",
  },
  {
    target: ".step3",
    content: "This is your profile details",
  },
  {
    target: ".step4",
    content: "This is your social details",
  },
  {
    target: ".step5",
    content: "This is your first Post",
  },
  {
    target: ".step6",
    content: "This is your social details",
  },
  {
    target: ".step7",
    content: "This is your social details",
  },
  {
    target: ".step8",
    content: "This is your social details",
  },
  {
    target: ".step9",
    content: "This is your social details",
  },
];
